import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"


import { reactive, ref, computed } from 'vue'
import { registerRecordPage, getRegisterDetail } from '@/api/yuntuSales/customerCenter'

const __default__ = { name: 'DcCosLbuRegisterLinksRecord' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  contactInfo: '',
  start: '',
  end: '',
  type: undefined
})
// 获取详情联系人信息
const showMask = (record: any, callBack: (res: any) => void) => {
  getRegisterDetail(record.id).then((res) => {
    const { contactInfo } = res.data
    callBack({ contactInfo })
  })
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await registerRecordPage({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '类型', dataIndex: 'type' },
  {
    title: '手机/邮件',
    dataIndex: 'contactInfo',
    cosType: 'mask'
  },
  { title: '发送人', dataIndex: 'operatorName' },
  { title: '发送时间', dataIndex: 'createTime' },
  { title: '结果', dataIndex: 'result' }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosRegisterLinksRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "手机号/邮箱" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactInfo,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.contactInfo) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "发送人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.operator,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.operator) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "发送时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.start,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.start) = $event)),
                        endTime: queryForm.end,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.end) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        ref: "select",
                        value: queryForm.type,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.type) = $event)),
                        allowClear: "",
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("全部")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode("短信")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode("邮箱")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'type')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(['邮件', '短信'][record.type]), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'result')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(['处理中', '成功', '失败'][record.result]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})